import React from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

// Assuming keel is imported correctly
import keel from "./images/logo.png";

const ReusablePDFLayout = ({
  children,
  headerstatus = false,
  footerstatus = false,
  padding = true,
}) => {
  return (
    <div
      style={
        padding
          ? {
              width: "210mm",
              height: "297mm",
              padding: "10mm 10mm",
              position: "relative",
              overflow: "hidden",

              backgroundColor: "white",

              boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
            }
          : {
              width: "210mm",
              height: "297mm",
              padding: "10mm 0",
              position: "relative",
              overflow: "hidden",
              backgroundColor: "white",
              boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
            }
      }
    >
      {headerstatus && (
        <div
          style={{
            display: "flex",
            padding: "0 10mm 0 20mm",
            justifyContent: "space-between",
          }}
        >
          <div>
            <img src={keel} height={"90px"} />
          </div>
          <div className="font-name" style={{ fontSize: "13px" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <p style={{ width: "60%" }}>CIN:</p>
              <p style={{ width: "70%" }}>U72900TN2022PTC155375</p>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <p style={{ width: "60%" }}>GSTIN:</p>
              <p style={{ width: "70%" }}>33AAJCK7889H1ZX</p>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <p style={{ width: "60%" }}>MAIL:</p>
              <p style={{ width: "70%" }}>info@keelis.com</p>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <p style={{ width: "60%" }}> WEB:</p>
              <p style={{ width: "70%" }}>www.keelis.com</p>
            </div>
          </div>
        </div>
      )}

      <div>{children}</div>
      {footerstatus && (
        <div className="footer">
          <p className="keel">KEEL INFO SOLUTION PRIVATE LIMITED</p>
          <p className="keelsec">
            2nd Floor, Santo Complex, 73 ESIC Nagar, 150 ft Agaram Main Road,
          </p>
          <p className="keelsec">Thiruvanchery, Chennai – 600126, TN, India.</p>
        </div>
      )}
    </div>
  );
};

export default ReusablePDFLayout;
